import { BASE_URL } from '@/config'

// Criar uma nova empresa
export async function createEnterprise(enterpriseData) {
  try {
    const response = await fetch(`${BASE_URL}/enterprise`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(enterpriseData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao criar empresa')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao criar empresa:', error)
    throw error
  }
}

// Obter todas as empresas
export async function getEnterprises() {
  try {
    const response = await fetch(`${BASE_URL}/enterprise`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar empresas')
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Erro ao buscar empresas:', error)
    throw error
  }
}

// Atualizar uma empresa pelo ID
export async function updateEnterprise(id, enterpriseData) {
  if (!id) {
    throw new Error('O ID da empresa é obrigatório para atualização.')
  }

  try {
    const response = await fetch(`${BASE_URL}/enterprise/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(enterpriseData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao atualizar empresa')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao atualizar empresa:', error)
    throw error
  }
}

// Excluir uma empresa pelo ID
export async function deleteEnterprise(id) {
  if (!id) {
    throw new Error('O ID da empresa é obrigatório para exclusão.')
  }

  try {
    const response = await fetch(`${BASE_URL}/enterprise/${id}`, {
      method: 'DELETE',
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao excluir empresa')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao excluir empresa:', error)
    throw error
  }
}

export async function getEnterpriseById(id) {
  if (!id) {
    throw new Error('O ID da empresa é obrigatório para busca.')
  }
  try {
    const response = await fetch(`${BASE_URL}/enterprise/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar empresa')
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar empresa:', error)
    throw error
  }
}
